import { Injectable } from '@angular/core';
import { IBuscarDocumentoReq } from '@core/interfaces/request-response/sunat.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class SunatApiService extends BaseHttpService {
  buscarDocumento<T>(request: IBuscarDocumentoReq) {
    return this.withLoader(
      this.httpClient.post<T>(
        `${environment.apiUrl}${environment.apiPreFix}/sunat/buscar-documento`,
        request,
      ),
    );
  }
}
